import Swiper from "swiper";
import { qs, qsAll } from "scripts/data_utils/domHelpers";
import Calculator from "scripts/services/circulation/calculator";
import PodFormPopup from "scripts/dom_utils/popups/pod_popup";
import { fetchOrderCost } from "scripts/data_utils/fetch_cost";
import numberFormatter from "scripts/data_utils/number_formatter";
import { MIN_PAGE_COUNT, MAX_PAGE_COUNT } from "scripts/constants";

function hideSliderLoader() {
  qs(".js-loader") && qs(".js-loader").classList.add("hide");
}

document.addEventListener("DOMContentLoaded", () => {
  const podCalculator = qs(".js-pod-calculator");
  let podSlider = qs(".js-slider-pod");
  const showPodModalBtn = qsAll(".js-show-pod-modal");
  const scrollToCalculatorButtons = qsAll(".js-to-calculator");
  showPodModalBtn.forEach(btn => btn.addEventListener("click", () => new PodFormPopup(btn)));

  if (podSlider && qsAll(".js_slide", podSlider).length > 4) {
    podSlider.classList.add("swiper-container");
    podSlider.parentNode.classList.remove("pod-calculator__slider--static");
    podSlider.parentNode.innerHTML += `
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    `;
    new Swiper(".js-slider-pod", {
      slidesPerView: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets"
      },
      on: {
        init: () => {
          setTimeout(() => {
            hideSliderLoader();
          }, 400);
        }
      }
    });
  } else {
    hideSliderLoader();
  }

  scrollToCalculatorButtons.map(button => {
    button.addEventListener("click", () => {
      qs(".pod-calculator__wrapper").scrollIntoView({
        behavior: "smooth"
      });
    });
  });
  podCalculator && new Calculator(podCalculator);
  podSlider = qs(".js-slider-pod");

  if (podSlider) {
    const podSlides = qsAll(".js_slide", podSlider);
    podSlides.forEach(async el => {
      const bookPageCount = el.dataset.pages;
      const requestParams = {
        pagesCount: bookPageCount,
        itemCount: 30
      };
      const data = await fetchOrderCost(requestParams);
      const {
        result: {
          print_cost: printCost
        }
      } = data;

      if (printCost) {
        const element = el.querySelector(".js-text-container");

        if (element === null) {
          return;
        }

        const price = numberFormatter(Math.floor(printCost / 20));

        if (bookPageCount >= MIN_PAGE_COUNT && bookPageCount <= MAX_PAGE_COUNT) {
          element.innerHTML = `
            <span class="text-green">≈ ${price} ₽</span> за книгу
            <div class="text-description">
              при заказе 30 экземпляров.
            </div>
          `;
        }
      }
    });
  }
});